import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatIDR } from '../lib/format';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { StatusBadge } from '../components/StatusBadge';
import { Copy, Users } from 'lucide-react';

const LVL_CLR = { L1: 'bg-[hsl(var(--brand-gold)/0.18)]', L2: 'bg-[hsl(var(--brand-ocean)/0.12)]', L3: 'bg-[hsl(var(--brand-teal)/0.14)]', L4: 'bg-muted' };

export default function Referral() {
  const [d, setD] = useState(null);
  const [comms, setComms] = useState([]);
  useEffect(() => {
    api.get('/referral/network').then(r => setD(r.data)).catch(()=>{});
    api.get('/referral/commissions').then(r => setComms(r.data.commissions)).catch(()=>{});
  }, []);
  if (!d) return <MemberLayout><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat...</div></MemberLayout>;

  const link = `${window.location.origin}/register?ref=${d.referral_code}`;

  return (
    <MemberLayout>
      <h1 className="font-display text-2xl sm:text-3xl font-bold">My Referral Network</h1>
      <p className="text-muted-foreground mt-1">Komisi hanya dari membership berbayar aktif & terverifikasi. Tunduk pada aturan program & anti-fraud.</p>

      <Card className="p-5 mt-6">
        <div className="text-sm text-muted-foreground">Kode Referral Anda</div>
        <div className="flex items-center gap-3 mt-2">
          <div className="font-mono font-bold text-lg">{d.referral_code}</div>
          <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(link); toast.success('Link disalin'); }} data-testid="copy-referral-button"><Copy className="h-3.5 w-3.5 mr-1" />Salin Link</Button>
        </div>
        <div className="text-xs text-muted-foreground mt-2 break-all">{link}</div>
      </Card>

      <div className="grid gap-4 sm:grid-cols-3 mt-6">
        <Card className="p-5"><div className="text-sm text-muted-foreground">Commission Generated</div><div className="font-display text-2xl font-bold mt-1 tabular-nums">{formatIDR(d.commission_generated)}</div></Card>
        <Card className="p-5"><div className="text-sm text-muted-foreground">Pending</div><div className="font-display text-2xl font-bold mt-1 tabular-nums">{formatIDR(d.commission_pending)}</div></Card>
        <Card className="p-5"><div className="text-sm text-muted-foreground">Paid</div><div className="font-display text-2xl font-bold mt-1 tabular-nums">{formatIDR(d.commission_paid)}</div></Card>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mt-6">
        {['L1','L2','L3','L4'].map(lvl => (
          <Card key={lvl} className={`p-5 ${LVL_CLR[lvl]}`}>
            <div className="flex items-center justify-between"><span className="font-semibold">Level {lvl.slice(1)}</span><Users className="h-4 w-4 text-muted-foreground" /></div>
            <div className="font-display text-3xl font-bold mt-2">{d.levels[lvl]?.count || 0}</div>
            <div className="text-xs text-muted-foreground mt-1">{d.levels[lvl]?.active || 0} aktif · {formatIDR(d.levels[lvl]?.rate || 0)}/bln</div>
          </Card>
        ))}
      </div>

      <Card className="p-5 mt-6">
        <h3 className="font-semibold mb-3">Riwayat Komisi</h3>
        {comms.length === 0 ? <p className="text-sm text-muted-foreground">Belum ada komisi.</p> : (
          <div className="space-y-2">
            {comms.map(c => (
              <div key={c.commission_id} className="flex items-center justify-between rounded-lg border px-3 py-2 text-sm">
                <div><span className="font-medium">{c.referred_name}</span> <span className="text-xs text-muted-foreground">· Level {c.level} · {c.period}</span></div>
                <div className="flex items-center gap-3"><span className="tabular-nums font-semibold">{formatIDR(c.amount)}</span><StatusBadge status={c.status} /></div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </MemberLayout>
  );
}
